import { LoadingOverlay } from 'src/design/atoms/LoadingOverlay';
import { Stack } from 'src/design/atoms/Stack';
import { Tabs } from 'src/design/molecules/Tabs';
import React from 'react';
import { JobDto } from 'src/api/FiretrolApiClient';
import { useMyServiceJobs } from 'src/api/queries/serviceJobs/useServiceJobs';
import { useAuth } from 'src/hooks/useAuth';
import { Header } from 'src/design/organisms/Header';
import { AllWorkTab } from 'src/routes/ServiceWork/components/AllWorkTab';
import { MyWorkTab } from 'src/routes/ServiceWork/components/MyWorkTab';

const EMPTY_JOBS: JobDto[] = [];

export const ServiceWork: React.FC = () => {
  const { scopes, isAdmin } = useAuth();
  const { data: myJobs = EMPTY_JOBS, isLoading } = useMyServiceJobs();

  const canViewAllWork = React.useMemo(() => {
    return isAdmin || scopes.includes('service_work_all');
  }, [scopes, isAdmin]);

  return (
    <Stack pos="relative">
      <LoadingOverlay visible={isLoading} />
      <Header
        title="Service Work"
        breadcrumbProps={{
          items: [{ text: 'Service Work' }],
        }}
        helpText="Manage and track service jobs. Service jobs allow technicians to track time and work performed outside of CTC jobs."
      />

      <Tabs defaultValue="my-work" keepMounted={false}>
        <Tabs.List>
          <Tabs.Tab value="my-work">My Work</Tabs.Tab>
          {canViewAllWork && <Tabs.Tab value="all-work">All Work</Tabs.Tab>}
        </Tabs.List>

        <Tabs.Panel value="my-work">
          <MyWorkTab jobs={myJobs} loading={isLoading} />
        </Tabs.Panel>

        {canViewAllWork && (
          <Tabs.Panel value="all-work">
            <AllWorkTab />
          </Tabs.Panel>
        )}
      </Tabs>
    </Stack>
  );
};
